/** @jsx jsx */
import { jsx, ThemeProvider, Flex } from 'theme-ui';
import Builder from '@builder.io/react';
import { CookiesProvider } from 'react-cookie';
import { RegionConfigProvider } from '../../utilities/RegionConfigContext';
import GlobalStyleHarrys from '../../gatsby-plugin-theme-ui/GlobalStyle';
import GlobalStyleLume from '../../gatsby-plugin-theme-ui-lume/GlobalStyle';
import GlobalStyleMando from '../../gatsby-plugin-theme-ui-mando/GlobalStyle';
import GlobalStyleHaven from '../../gatsby-plugin-theme-ui-haven/GlobalStyle';
import GlobalStyleSpruce from '../../gatsby-plugin-theme-ui-spruce/GlobalStyle';
import themeHarrys from '../../gatsby-plugin-theme-ui';
import themeLume from '../../gatsby-plugin-theme-ui-lume';
import themeMando from '../../gatsby-plugin-theme-ui-mando';
import themeHaven from '../../gatsby-plugin-theme-ui-haven';
import themeSpruce from '../../gatsby-plugin-theme-ui-spruce';


/*
- If a page has no regionConfig, it will not render a Header, Footer, noscript Iframe. An example is the index page ("/")

- The bodyGTMIframe is a <noscript> tag with a *text* representation of an <iframe> as the content inside
-- The height="0" width="0" iframe will not visually display, but will make a request to the src, which is used to count users who have JS disabled
-- if the newline breaks of `{regionConfig?.bodyGTMIframe && ` logic are removed, it will not include bodyGTMIframe, effectively breaking it
*/

const Layout = ({ backgroundColor, regionConfig, children }) => {

  // Default to Harry's styles
  var GlobalStyle = GlobalStyleHarrys,
      theme = themeHarrys;

  if(regionConfig) {
    switch(regionConfig.brand) {
      case 'kelly':
        GlobalStyle = GlobalStyleHaven;
        theme = themeHaven;
        break;
      case 'lume':
        GlobalStyle = GlobalStyleLume;
        theme = themeLume;
        break;
      case 'mando':
        GlobalStyle = GlobalStyleMando;
        theme = themeMando;
        break;
      case 'spruce':
        GlobalStyle = GlobalStyleSpruce;
        theme = themeSpruce;
        break;
    }
  }

  return (
    <CookiesProvider>
      <RegionConfigProvider regionConfig={regionConfig}>
        <GlobalStyle />
        <ThemeProvider theme={theme}>
          <Flex
          sx={{
            backgroundColor,
            flexDirection: 'column',
            fontFamily: 'body',
            minHeight: '100vh',

            h1: theme.styles.root.h1,
            h2: theme.styles.root.h2,
            h3: theme.styles.root.h3,
            h4: theme.styles.root.h4,
            h5: theme.styles.root.h5,
            h6: theme.styles.root.h6,
            h7: theme.styles.root.h7,
            p: theme.styles.root.p
          }}
        >
          <main
            sx={{
              width: '100%',
              flex: '1 1 auto',
            }}
          >
            {children}
          </main>
          
        </Flex>
      </ThemeProvider>
      </RegionConfigProvider>
    </CookiesProvider>
  );
};

export default Layout;
